import { Pipe, PipeTransform } from '@angular/core';
import { PatientCaseListDataModel } from '../models/PatientCaseListData.model';


@Pipe({
  name: 'paBookAppointmentCasePipe'
})
export class PaBookAppointmentCasePipePipe implements PipeTransform {

  
  transform(caseData: PatientCaseListDataModel[], searchTermCaseeList: string): PatientCaseListDataModel[]{
    if (!caseData || !searchTermCaseeList) { return caseData; }
    return caseData.filter(ad =>
     
    
      ad.caseName.toLowerCase().indexOf(searchTermCaseeList.toLowerCase().trim()) !== -1 
  
  
  
  
    );
  }

}
